import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetTestConfigTaskSummaryResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: (data: GetTestConfigTaskSummaryResponse) => void
  children?: (data: GetTestConfigTaskSummaryResponse) => ReactElement
}

const GetAiTestConfigTaskSummaryRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks/${id}/summary`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiTestConfigTaskSummaryRequest
